import useUser from "@app/zustand/user";
import { usePreviewView } from "@app/zustand/preview-view";
import { useIsReviewer } from "@app/utils/use-is-reviewer";
import { useReadonlyScope } from "@app/utils/use-readonly-scope";

/**
 * Returns true if the session can trigger pipeline steps: an admin or one of MAGE-X's reviewers.
 *
 * Never inside a borrowed speciality (PT-74): this gate also carries the source synchronisation,
 * the dossier reading — the most expensive gesture on the platform — and the EuroSpine transfer, which
 * sends a dossier out of the platform entirely.
 */
export function useCanRunPipeline(): boolean {
  const user = useUser((state) => state.user);
  const previewRole = usePreviewView((state) => state.previewRole);
  const readonlyScope = useReadonlyScope();
  const isReviewer = useIsReviewer();
  const userRole = (user as { role?: string } | null)?.role;
  const effectiveRole = previewRole ?? userRole;
  if (readonlyScope) return false;
  return effectiveRole === "admin" || isReviewer;
}
